import React, { useCallback } from "react";
import classes from './style.module.scss';
import { useStoreState } from "~/store";
import useTranslation from "~/app/hooks/useTranslation";
import Button from "~/app/common/Button";
import { useHistory, useParams } from "react-router";
import { MACHINES_DETAILS_ROUTES } from "~/machines/Details/Router";
import { route } from "~/app/helpers/route";
import { Machine, Service } from "~/types";

export type ServiceChecklistComponent = React.FC;

const ServiceChecklistSection: ServiceChecklistComponent = () => {

  const netWorkStatus = useStoreState(state => state.app.offline.status);
  const completed = useStoreState(state => state.service.data.checklist.filter(check => check.status !== null).length);
  const total = useStoreState(state => state.service.data.checklist.filter(check => check.isServiceSection === false).length);
  const { id, serviceId } = useParams<{ id: Machine['id'], serviceId: Service['id'] }>();
  const { t } = useTranslation('service');
  const history = useHistory();

  const handleOpenChecklist = useCallback(() => {
    history.push(route(MACHINES_DETAILS_ROUTES.serviceCheck, { id, serviceId }));
  }, [history, id, serviceId]);
  
  return (
    <>
      <div className={classes['container']}>
        <div className={classes['header']}>
          <div className={classes['section']}>
            <span className={classes['headerText']}>{t('checklist')}</span>
            <span>{t('checkpointsCompleted', { completed, total })}</span>
          </div>
          {!netWorkStatus && (
            <Button className={classes['addButton']} onClick={handleOpenChecklist}>{`${t('open')} ${t('checklist')}`}</Button>
          )}
        </div>
        <hr className={classes['bottomLine']} />
      </div>
    </>
  )
}

export default ServiceChecklistSection;